<mat-form-field
  class="ccs-select {{ size }}"
  [hideRequiredMarker]="true"
  [floatLabel]="floatLabel">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    hideSingleSelectionIndicator
    [multiple]="multiple"
    [appCanAutoFocus]="autofocus"
    [formControl]="control"
    [placeholder]="placeholder"
    (focus)="onFocus.emit($event)"
    (blur)="onBlur.emit($event)"
    (selectionChange)="onSelectionChange.emit($event)"
    (openedChange)="onOpenedChange.emit($event)"
    panelClass="ccs-select__panel">
    @for (option of options; track option) {
      <mat-option [value]="option[valueKey]">
        {{ option[displayKey] }}
      </mat-option>
    }
  </mat-select>

  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }

  <mat-error>
    {{ control.errors | errorMessage: errorMessages }}
  </mat-error>
</mat-form-field>
